import { CSSProperties } from "react";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

interface TranscriptSectionSkeletonProps {
  rows?: number;
  className?: string;
  showHeader?: boolean;
}

const lineAnimationStyle = (delay: number): CSSProperties => ({
  animationName: "skeleton-line-glow",
  animationDuration: "2s",
  animationTimingFunction: "ease-in-out",
  animationIterationCount: "infinite",
  animationDelay: `${delay}s`,
});

// 预设不同的文本宽度，让 skeleton 看起来更自然
const textWidths = ["w-[85%]", "w-[70%]", "w-[90%]", "w-[60%]"];

export function TranscriptSectionSkeleton({
  rows = 4,
  className,
  showHeader = true,
}: TranscriptSectionSkeletonProps) {
  const placeholders = Array.from({ length: rows });

  return (
    <div
      className={cn(
        "transcript-content-container mt-1 bg-background/30 backdrop-blur-sm rounded-3xl border border-border/50",
        className
      )}
    >
      {showHeader && (
        <div className="flex items-center justify-between mb-4 p-3 sm:p-4 border-b border-border/50">
          <div className="flex items-center space-x-3">
            <Skeleton
              className="skeleton-line h-6 w-2 rounded-full bg-primary/20"
              style={lineAnimationStyle(0)}
            />
            <Skeleton
              className="skeleton-line h-5 w-24"
              style={lineAnimationStyle(0.1)}
            />
          </div>
          <Skeleton
            className="skeleton-line h-4 w-20"
            style={lineAnimationStyle(0.2)}
          />
        </div>
      )}
      <div className="px-3 sm:px-4 py-3 space-y-6 pb-[calc(env(safe-area-inset-bottom)+6rem)] sm:pb-12">
        {placeholders.map((_, index) => (
          <div key={`transcript-skeleton-${index}`} className="space-y-2.5">
            {/* 时间戳 skeleton */}
            <Skeleton
              className="skeleton-line h-3 w-12 rounded-md"
              style={lineAnimationStyle(index * 0.25)}
            />
            {/* 文本 skeleton - 只显示一行，宽度随机 */}
            <Skeleton
              className={cn(
                "skeleton-line h-5 rounded-md",
                textWidths[index % textWidths.length]
              )}
              style={lineAnimationStyle(index * 0.25 + 0.12)}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
